var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { onMounted } from 'vue';
import { useAcknowledgementStore, useAuthStore } from "../../store";
import LoadingProcessing from '../atoms/LoadingProcessing.vue';
import * as $gtag from "vue-gtag";
import { backToAfterSignin } from '../../utils';
export default /*#__PURE__*/ _defineComponent({
    __name: 'OauthGoogleSign',
    setup: function (__props) {
        var _this = this;
        var authStore = useAuthStore();
        var acknowledgementStore = useAcknowledgementStore();
        var pageURL = new URL(window.location.href);
        var params = pageURL.searchParams;
        var code = params.get('code');
        var state = params.get('state');
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            var res, domain, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, authStore.signInWithSns({
                                code: String(code),
                                provider: 'google_oauth2',
                            })];
                    case 1:
                        res = _a.sent();
                        if (res.data.user.url_flg) {
                            if (res.data.user.url_flg == '1' || res.data.user.url_flg == '4') {
                                window.location.href = '/registrations/oauth/';
                            }
                            else if (res.data.user.url_flg == '5') {
                                window.location.href = '/registrations/complete/';
                            }
                            else if (res.data.user.url_flg == '6') {
                                window.location.href = '/registrations/oauth/nickname/';
                            }
                            else {
                                backToAfterSignin();
                            }
                        }
                        else {
                            domain = window.location.host;
                            if (domain === 'media.engate.jp') {
                                $gtag.event('click', { event_category: 'login', event_label: 'login_google' });
                            }
                            backToAfterSignin();
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        console.log(err_1);
                        acknowledgementStore.showAcknowledgement({
                            code: err_1.code,
                            message: err_1.message,
                            to: '/signin/'
                        });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); });
        return function (_ctx, _cache) {
            return (_openBlock(), _createBlock(LoadingProcessing, { "is-loading": true }));
        };
    }
});
